import axios from 'axios';
import Cookies from 'universal-cookie';

// El endpoint /Database/Schema ahora exige JWT (rol Super-Admin). Adjuntamos el token.
const getAuthHeaders = () => {
  const token = new Cookies().get('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Intenta obtener un listado de tablas/columnas desde el backend.
// Si el endpoint no existe o falla, devolvemos un fallback (útil para desarrollo).
//
// Contrato esperado (si existe en backend):
// - GET /Database/Schema/Tables -> string[] | { tables: string[] }
// - GET /Database/Schema/Columns/{table} -> string[] | { columns: string[] } | { name: string }[]

const FALLBACK_TABLES = [];

const FALLBACK_COLUMNS_BY_TABLE = {
  // ejemplo:
  // clientes: ['nombre', 'rut', 'telefono', 'email', 'created_at']
};

function normalizeStringArray(payload) {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload.tables)) return payload.tables;
  if (Array.isArray(payload.columns)) return payload.columns;
  return [];
}

function normalizeColumns(payload) {
  // Puede venir como string[] o como {name}[]
  if (!payload) return [];
  if (Array.isArray(payload)) {
    if (payload.length === 0) return [];
    if (typeof payload[0] === 'string') return payload;
    if (payload[0] && typeof payload[0] === 'object') {
      return payload
        .map((c) => c.name || c.column || c.columnName)
        .filter(Boolean);
    }
  }
  if (Array.isArray(payload.columns)) {
    return payload.columns
      .map((c) => (typeof c === 'string' ? c : c?.name || c?.column || c?.columnName))
      .filter(Boolean);
  }
  return [];
}

export async function listDatabaseTables() {
  const url = `${window.API_URL}/Database/Schema/Tables`;
  try {
    const res = await axios.get(url, { headers: getAuthHeaders() });
    const tables = normalizeStringArray(res.data);
    return tables.length ? tables : FALLBACK_TABLES;
  } catch (e) {
    // fallback silencioso
    return FALLBACK_TABLES;
  }
}

export async function listDatabaseColumns(table) {
  if (!table) return [];
  const url = `${window.API_URL}/Database/Schema/Columns/${encodeURIComponent(table)}`;
  try {
    const res = await axios.get(url, { headers: getAuthHeaders() });
    const cols = normalizeColumns(res.data);
    if (cols.length) return cols;
  } catch (e) {
    // ignore
  }

  return FALLBACK_COLUMNS_BY_TABLE[table] || [];
}
